export const CURRENCY_LABELS: Record<string, string> = {
  BTC: "Bitcoin (BTC)",
  ETH: "Ethereum (ETH)",
  TRX: "Tron (TRX)",
  USDT: "USDT",
};
